// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/login';
import Calculator from './pages/calculator';
import Admin from './pages/admin';
import Invite from './pages/invite';
import { AuthProvider, RequireAdmin, RequireAuth } from './auth';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/invite/:token" element={<Invite />} />
          <Route path="/calculator" element={<RequireAuth><Calculator /></RequireAuth>} />
          <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/calculator" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
